import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { Alert, TableSortLabel } from "@mui/material";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import { Box } from "@mui/system";
//import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
//import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
//import ContrastOutlinedIcon from '@mui/icons-material/ContrastOutlined';
//import RecommendOutlinedIcon from "@mui/icons-material/RecommendOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const DeleteReceiptTable = ({ tableHeadings, rows }: Props) => {
  const headCells = Object.entries(tableHeadings);

  return (
    <>
      <TableContainer className="receiptsTable " sx={{ my: 3 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value && typeof value === "string" ? value : ""}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <React.Fragment key={row.cron_id}>
                <TableRow
                  sx={{
                    "& > *": {
                      borderBottom:
                        "1px solid rgba(224, 224, 224, 1) !important",
                    },
                  }}
                >
                  {headCells.map(([key], cellIndex) => (
                    <TableCell key={cellIndex} align="left">
                      {key === "company" ? (
                        <>{row[key] ? row[key] : "N/A"}</>
                      ) : key === "receipt_number" ? (
                        <>{row[key] ? row[key] : "N/A"}</>
                      ) : key === "receipt_amount" ? (
                        <>
                          <Box display={"flex"} alignItems={"center"}>
                            {row[key] ? row[key] : "N/A"}{" "}
                            <CurrencyPoundIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.56)",
                                fontSize: "20px",
                                ml: 1,
                              }}
                            />
                          </Box>
                        </>
                      ) : key === "fme" ? (
                        <>{row[key] ? row[key] : "N/A"}</>
                      ) : key === "credit" ? (
                        <>
                          <Box display={"flex"} alignItems={"center"}>
                            {row[key] ? row[key] : "N/A"}{" "}
                            <CurrencyPoundIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.56)",
                                fontSize: "20px",
                                ml: 1,
                              }}
                            />
                          </Box>
                        </>
                      ) : key === "debit" ? (
                        <>
                          <Box display={"flex"} alignItems={"center"}>
                            {row[key] ? row[key] : "N/A"}{" "}
                            <CurrencyPoundIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.56)",
                                fontSize: "20px",
                                ml: 1,
                              }}
                            />
                          </Box>
                        </>
                      ) : key === "covered" ? (
                        <>{row[key] ? row[key] : "N/A"}</>
                      ) : key === "fme_status" ? (
                        <>
                          <Box display={"flex"} alignItems={"center"}>
                            <div className="AlertItems">
                              <Alert
                                icon={
                                  <ErrorOutlineIcon
                                    fontSize="inherit"
                                    sx={{ color: "rgba(95, 33, 32, 1)" }}
                                  />
                                }
                                severity="error"
                                sx={{
                                  border: "1px solid rgba(211, 47, 47, 0.5)",
                                  padding: "0px 5px",
                                  display: "inline-flex",
                                }}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>

                              {/* <Alert
                                icon={
                                  <RecommendOutlinedIcon
                                    fontSize="inherit"
                                    sx={{ color: "rgba(1, 67, 97, 1)" }}
                                  />
                                }
                                severity="info"
                                sx={{
                                  border: "1px solid rgba(33, 150, 243, 0.5)",
                                  padding: "0px 5px",
                                  display: "inline-flex",
                                }}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>

                              <Alert
                                icon={
                                  <ContrastOutlinedIcon
                                    fontSize="inherit"
                                    sx={{ color: "rgba(30, 70, 32, 1)" }}
                                  />
                                }
                                severity="success"
                                sx={{
                                  border: "1px solid rgba(46, 125, 50, 0.5)",
                                  padding: "0px 5px",
                                  display: "inline-flex",
                                }}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>

                              <Alert
                                icon={
                                  <PaidOutlinedIcon
                                    fontSize="inherit"
                                    sx={{ color: "rgba(30, 70, 32, 1)" }}
                                  />
                                }
                                severity="success"
                                sx={{
                                  border: "1px solid rgba(46, 125, 50, 0.5)",
                                  padding: "0px 5px",
                                  display: "inline-flex",
                                }}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>

                              <Alert
                                icon={
                                  <PendingOutlinedIcon
                                    fontSize="inherit"
                                    sx={{ color: "rgba(1, 67, 97, 1)" }}
                                  />
                                }
                                severity="info"
                                sx={{
                                  border: "1px solid rgba(33, 150, 243, 0.5)",
                                  padding: "0px 5px",
                                  display: "inline-flex",
                                }}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert> */}
                            </div>
                          </Box>
                        </>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DeleteReceiptTable;
